import React, { FC } from "react";

type IProps = {
  width?: string;
  height?: string;
  color?: string;
};

const Play: FC<IProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ? width : "40"}
      height={height ? height : "40"}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#FD8533" />
      <path
        d="M26.4 18.6037C27.4667 19.2243 27.4667 20.7757 26.4 21.3963L16.8 26.9816C15.7333 27.6022 14.4 26.8264 14.4 25.5853L14.4 14.4147C14.4 13.1735 15.7333 12.3978 16.8 13.0184L26.4 18.6037Z"
        fill="white"
      />
    </svg>
  );
};

export default Play;
